import React from "react";
import { i18n } from "../../translate/i18n";

const ThemeToggle = ({ theme, onToggle }) => {
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={onToggle}
      aria-label={i18n.t("home.themeToggle")}
      title={i18n.t("home.themeToggle")}
    >
      <span className={`theme-icon ${isDark ? "active" : ""}`} aria-hidden="true">🌙</span>
      <span className={`theme-icon ${!isDark ? "active" : ""}`} aria-hidden="true">☀️</span>
    </button>
  );
};

export default ThemeToggle;
